import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addUpdateSingleCMS, addUpdateSingleFAQ, cmsList, contactUsList, deleteSingleCMS, faqList } from "../apis/apiHandler";

export const cms = createAsyncThunk(
    "cms/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await cmsList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addUpdateCms = createAsyncThunk(
    "cms/add_update",
    async (payload , { rejectWithValue }) => {
        try {
            const response = await addUpdateSingleCMS(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteCms = createAsyncThunk(
    "cms/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleCMS(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addUpdateFaq = createAsyncThunk(
    "faq/add_update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addUpdateSingleFAQ(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const faq = createAsyncThunk(
    "faq/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await faqList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const contactUs = createAsyncThunk(
    "contact_us/list",
    async (payload, { rejectWithValue }) => {
        try {
            
            const response = await contactUsList(payload);
            

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);


const initialState = {
    loading: false,
    cmsList: [],
    faqList: [],
    contactUsList: [],
    addUpdatecmsData: {},
    addUpdateFaqData: {},
    deleteCmsData: {},
    error: null,
    success: false,
};

const cmsSlice = createSlice({
    name: "blog",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(cms.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(cms.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.cmsList = payload;
                state.success = true;
            })
            .addCase(cms.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addUpdateCms.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addUpdateCms.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addUpdatecmsData = payload;
                state.success = true;
            })
            .addCase(addUpdateCms.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteCms.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteCms.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteCmsData = payload;
                state.success = true;
            })
            .addCase(deleteCms.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addUpdateFaq.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addUpdateFaq.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addUpdateFaqData = payload;
                state.success = true;
            })
            .addCase(addUpdateFaq.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(faq.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(faq.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.faqList = payload;
                state.success = true;
            })
            .addCase(faq.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(contactUs.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(contactUs.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.contactUsList = payload;
                state.success = true;
            })
            .addCase(contactUs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default cmsSlice.reducer;
